package io.horion.auth

import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.background
import com.varabyte.kobweb.silk.theme.colors.palette.color
import io.horion.auth.presentation.ui.theme.AuthTheme

class SitePalette(
    val nearBackground: Color,
    val cobweb: Color,
    val brand: Brand,
) {
    class Brand(
        val primary: Color = Color.rgb(0x003366),
        val accent: Color  = Color.rgb(0x00C2FF),
    )
}

object SitePalettes {
    val light = SitePalette(
        nearBackground = Color.rgb(0xF4F6FA),
        cobweb = Colors.LightGray,
        brand = SitePalette.Brand(
            primary = Color.rgb(0x003366),
            accent  = Color.rgb(0x00C2FF)
        )
    )
    val dark = SitePalette(
        nearBackground = Color.rgb(0x0D1117),
        cobweb = Colors.LightGray.inverted(),
        brand = SitePalette.Brand(
            primary = Color.rgb(0x4A9EFF),
            accent  = Color.rgb(0x00C2FF),
        )
    )
}

fun ColorMode.toSitePalette(): SitePalette = when (this) {
    ColorMode.LIGHT -> SitePalettes.light
    ColorMode.DARK  -> SitePalettes.dark
}

@InitSilk
fun initTheme(ctx: InitSilkContext) {
    ctx.theme.palettes.light.apply {
        background = AuthTheme.light.background
        color = AuthTheme.light.onBackground
    }

    ctx.theme.palettes.dark.apply {
        background = AuthTheme.dark.background
        color = AuthTheme.dark.onBackground
    }
}
